<template>
  <div class="content_box" style="background-color: #f5f6fa">
    <hear></hear>
    <div class="content xcontent">
      <el-tabs stylt="height: 100%;" v-model="tab" :tab-position="tabPosition">
        <el-tab-pane name="first" label="个人中心">
          <!-- 判断下是否实名，未实名要实名 打开下方注释 -->
          <!-- <div class="rzBox">
              <el-button @click="shiming" type="" class="but">请实名认证</el-button>
          </div> -->
          <div class="personal_box">
            <div class="Personal">
              <el-form
                :label-position="labelPosition"
                label-width="80px"
                :model="ziliaolist"
              >
                <el-form-item label="姓名" class="con">
                  <el-input disabled v-model="ziliaolist.cardname"></el-input>
                </el-form-item>
                <el-form-item disabled label="手机号码" class="con">
                  <el-input disabled v-model="ziliaolist.mobile"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" class="con">
                  <el-input disabled v-model="ziliaolist.cardcode"></el-input>
                </el-form-item>
                <el-form-item label="身份证" class="con"> </el-form-item>
              </el-form>
              <div class="imgBox">
                <el-image
                  style="width: 80%;height: 200px;margin-bottom: 10px;"
                  :preview-src-list="[$baseUrl + ziliaolist.cardfront]"
                  :src="$baseUrl + ziliaolist.cardfront"
                  alt=""
                />
                <el-image
                  style="width: 80%;height: 200px;margin-bottom: 10px;"
                  :preview-src-list="[$baseUrl + ziliaolist.cardback]"
                  :src="$baseUrl + ziliaolist.cardback"
                  alt=""
                />
              </div>
              <div style="display: flex; justify-content: center;">
                <el-button style="width: 40%;" @click="outs" type="" class="but"
                  >退出</el-button
                >
              </div>
              <!-- <el-button type="" class="but">注销</el-button> -->
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second" label="我的快递">
          <div
            style="
              padding: 0 20px;
              display: flex;
              justify-content: space-between;
              padding-top: 10px;
              padding-bottom: 10px;
              border-bottom: 3px #ebecef solid;
            "
          >
            <div style="display: flex">
              <el-button
                @click="kuaidishuaxin"
                type="info"
                icon="el-icon-refresh-right"
                class="anniu"
              ></el-button>
              <el-button
                class="anniu"
                type="success"
                style="width: 70px;"
                @click="handkuaidi"
                >申请快递</el-button
              >
            </div>
            <div
              style="display: flex; justify-content: space-around"
            >
              <el-row
                style="display: flex; justify-content: flex-end;"
                @click="getKuaidi"
                class="mb8"
              >
                <el-col :span="19" class="seach">
                  <el-input v-model="jigouName"  clearable placeholder="请输入"></el-input>
                  <el-button type="primary" icon="el-icon-search"></el-button>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="card_father">
            <el-table
              ref="multipleTable"
              :data="kuaidilist"
              tooltip-effect="dark"
              class="table kiai xtable"
              stripe
              border
              align="center"
              v-loading="loading"
              highlight-current-row
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                prop="order_no"
                :show-overflow-tooltip="true"
                width="160"
                align="order_no"
                label="订单号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="express_no"
                label="物流单号"
                :show-overflow-tooltip="true"
                width="160"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="goods_name"
                label="产品名称"
                :show-overflow-tooltip="true"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="goods_count"
                label="产品数量"
                align="center"
                :show-overflow-tooltip="true"
                width="120"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="goods_amount"
                label="产品价格"
                :show-overflow-tooltip="true"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="receive_company"
                label="收件方"
                align="center"
                :show-overflow-tooltip="true"
                width="120"
              ></el-table-column>
              <el-table-column align="payMethod" label="付款方式">
                <template slot-scope="scope">
                  {{
                    scope.row.payMethod == 1
                      ? "寄方付"
                      : scope.row.payMethod == 2
                      ? "收方付"
                      : "第三方付"
                  }}
                </template>
              </el-table-column>
              <el-table-column align="payMethod" label="当前进度">
                <template slot-scope="scope">
                  {{
                    scope.row.status == 1
                      ? "已创建"
                      : scope.row.status == 2
                      ? "已提交"
                      : scope.row.status == 3
                      ? "已发货"
                      : scope.row.status == 4
                      ? "已收货"
                      : "已取消"
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="scope"
                :show-overflow-tooltip="true"
                width="120"
                fixed="right"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="chakan(scope.row)" size="small"
                    >查看详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="block">
            <el-pagination
              background
              @size-change="handleSizeChange_kuaidi"
              @current-change="handleCurrentChange_kuaidi"
              :page-sizes="[10, 20, 30]"
              :page-size="kuaidi_params.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="kuaidi_total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="third" label="我的保函">
          <div class="wuhuxin">
            <div
              style="
              padding: 0 20px;
              display: flex;
              justify-content: space-between;
              padding-top: 10px;
              padding-bottom: 10px;
              border-bottom: 3px #ebecef solid;
            "
            >
              <div style="display: flex">
                <el-button
                  type="info"
                  icon="el-icon-refresh-right"
                  class="anniu"
                  @click="getBhlist()"
                ></el-button>
                <!-- <el-button
                class="anniu"
                type="success"
                icon="el-icon-plus"
                @click="handleAdd"
                >添加</el-button> -->
              </div>
              <div
                style="display: flex; justify-content: space-around"
              >
                <el-row
                  style="display: flex; justify-content:flex-end;"
                  class="mb8"
                >
                  <el-col :span="19" class="seach">
                    <el-input
                    clearable
                      v-model="jigouName"
                      placeholder="请输入"
                    ></el-input>

                    <el-button type="primary" icon="el-icon-search"></el-button>
                  </el-col>
                </el-row>
                <!-- <el-input class="anniu" v-model="jigouName" placeholder="请输入"></el-input>
              <el-button class="anniu" type="primary" icon="el-icon-search"></el-button> -->
              </div>
            </div>
            <div class="card_fathers">
              <div class="cards" v-for="item in Bh_list" :key="item.id">
                <div class="card_bh">
                  <div class="card_content_top">
                    <div class="card_left">
                      <div class="top_right">{{ item.gtype }}</div>
                      <span class="top_title">{{ item.bidding_name }}</span>
                    </div>
                    <div @click="bhchakan(item)" class="card_right">
                      <div>查看详情</div>
                    </div>
                  </div>
                  <div class="card_details">
                    <div class="every">
                      <i class="el-icon-s-order"></i>
                      <div>标段编号：{{ item.bidding_number }}</div>
                    </div>
                    <div class="every">
                      <i class="el-icon-s-order"></i>
                      <div>保证金金额：{{ item.margin_amount }}</div>
                    </div>

                    <div class="every">
                      <i class="el-icon-s-order"></i>
                      <div>申请时间：{{ item.create_time | dateFormat }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="block">
              <el-pagination
                background
                @size-change="handleSizeChange_baohan"
                @current-change="handleCurrentChange_baohan"
                :page-sizes="[10, 20, 30]"
                :page-size="Bh_details.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="Bh_total"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <!-- 完结 -->
        <el-tab-pane name="dizhi" style="padding: 5px" label="我的地址">
          <div
            style="
            display: flex;
            justify-content: space-between;
            padding-bottom: 5px;
            border-bottom: 3px #ebecef solid;
          "
          >
            <div style="display: flex">
              <el-button
                style="height: 35px; align-items: center; display: flex"
                type="info"
                icon="el-icon-refresh-right"
                class="anniu"
                @click="shuxindizhi"
              ></el-button>
              <el-button
                @click="addAddress"
                style="
                height: 35px;
                align-items: center;
                display: flex;
                width: 100px;
              "
                class="anniu"
                type="success"
                >新增地址</el-button
              >
            </div>
            <div style="display: flex;  justify-content: flex-end">
              <el-row style="display: flex; justify-content: flex-end;" class="mb8">
                <el-col :span="19" class="seach">
                  <el-input v-model="jigouName"  clearable placeholder="请输入"></el-input>

                  <el-button type="primary" icon="el-icon-search"></el-button>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            style="flex:1; display: flex; width: 100%;overflow: auto;"
            class="box-card"
          >
            <div style="width: 100%; width: 100%">
              <div
                class="box-card-box"
                :key="item.name"
                v-for="item in dizhilist"
                style="
                display: flex;
                width: 100%;
                padding: 10px;
                justify-content: space-between;
                background: #fff;
                margin-top: 10px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12),
                  0 0 6px rgba(0, 0, 0, 0.04);
                  border: 3px solid #f5f6fa;
              "
              >
                <div class="box-card-left">
                  <div class="box-card-top">
                    <h1>{{ cardname }}</h1>
                    <span>{{ username }}</span>
                    <div v-show="item.status == 2" class="moren">默认</div>
                  </div>
                  <div>
                    <span>地址：</span>
                    <span>{{ item.province }}</span>
                    <span>{{ item.city }}</span>
                    <span>{{ item.area }}</span>
                    <span>{{ item.address }}</span>
                  </div>
                </div>
                <div
                  style="    display: flex;
    align-items: center;
}"
                  class="box-card-right"
                >
                  <el-button type="primary" @click="editAddress(item)"
                    >编辑</el-button
                  >
                  <el-button type="danger" @click="delAddress(item.id)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <el-pagination
              background
              @size-change="handleSizeChange_dizhi"
              @current-change="handleCurrentChange_dizhi"
              :page-sizes="[10, 20, 30]"
              :page-size="dizhi_params.limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="dizhi_total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="fourth" label="修改密码">
          <div class="update_password">
            <div class="update">
              <el-form
                :label-position="labelPosition"
                label-width="100px"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-row :gutter="10">
                  <el-col :span="24">
                    <el-form-item label="原密码:">
                      <el-input
                        v-model="form.old_password"
                        placeholder="请输入原密码"
                        clearable
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="新密码:">
                      <el-input
                        v-model="form.password"
                        type="password"
                        clearable
                        placeholder="请输入新密码"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="确认新密码:">
                      <el-input
                        v-model="password_again"
                        type="password"
                        clearable
                        placeholder="请再次输入新密码"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- <el-form-item class="but-con">
                </el-form-item> -->
              </el-form>
              <el-button class="but but-con" type="" @click="updatepassword"
                >确认修改</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- <el-dialog
      title="实名认证"
      :visible.sync="open6"
      :close-on-click-modal="false"
      v-dialogDrag
      width="50%"
      custom-class="shiming"
    >
      <el-form
        class="renzhng"
        :label-position="labelPosition"
        label-width="80px"
        :model="formInfo"
      >
        <el-form-item label="姓名" class="con">
          <el-input v-model="formInfo.cardname"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" class="con">
          <el-input v-model="formInfo.mobile"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" class="con">
          <el-input v-model="formInfo.cardcode"></el-input>
        </el-form-item>
        <el-form-item label="身份证" class="con">
          <div class="avatar" v-if="formInfo.cardfront">
            <img
              :src="$baseUrl + formInfo.cardfront"
              @click="handlePictureCardPreview()"
            />
            <i class="el-icon-delete" @click="handleRemove1()"></i>
          </div>
          <el-upload
            v-else
            class="avatar-uploader"
            :action="imgUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess1"
          >
            <div class="avatar-uploader-icon">
              <i class="el-icon-plus"></i>
              <span>身份证正面</span>
            </div>
          </el-upload>
          <div class="avatar" v-if="formInfo.cardback">
            <img
              :src="$baseUrl + formInfo.cardback"
              @click="handlePictureCardPreview()"
            />
            <i class="el-icon-delete" @click="handleRemove2()"></i>
          </div>
          <el-upload
            v-else
            class="avatar-uploader"
            :action="imgUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
          >
            <div class="avatar-uploader-icon">
              <i class="el-icon-plus"></i>
              <span>身份证反面</span>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="save" type="" class="btn">提交</el-button>
        <el-button type="" class="but">取消</el-button>
      </div>
    </el-dialog> -->
    <el-dialog
      :title="title"
      :visible.sync="open10"
      width="50%"
      :close-on-click-modal="false"
      v-dialogDrag
      custom-class="publicDialog"
    >
      <el-form
        ref="formAdress"
        :model="formAdress"
        label-width="150px"
        class=""
      >
        <!-- <el-form-item label="收货人 :">
          <el-input v-model="formAdress.name"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="联系方式 :">
          <el-input v-model="formAdress.mobile"></el-input>
        </el-form-item> -->
        <el-form-item label="地址 :">
          <region-selects @change="regionChange" v-model="addressDemo" />
        </el-form-item>
        <!-- <el-form-item label="详细地址 :">
          <el-input type="textarea" v-model="formAdress.address"></el-input>
        </el-form-item> -->
        <el-form-item label="详细地址 :">
          <el-input type="textarea" v-model="formAdress.address"></el-input>
        </el-form-item>
        <el-form-item label="状态 :">
          <el-radio-group v-model="formAdress.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">默认</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="" class="btn" @click="saveAddress">提交</el-button>
        <el-button type="" class="btn" @click="open10 == false">取消</el-button>
      </div>
    </el-dialog>
    <binad></binad>
  </div>
</template>

<script>
import binad from ".././../components/dinad.vue";
import hear from "@/components/hear.vue";
import cioand from "@/view/Guarantee/cioands.vue";
import { RegionSelects } from "v-region";
import {
  kuaidi,
  ziliao,
  bhlist,
  bh_detail,
  fapiao,
  password,
  logou,
  shenqingkaipiao,
  renzheng_geren,
  addresslist
} from "@/api/system/usercenter.js";
import { addaddress, deladdress, saveaddress } from "@/api/xin.js";
export default {
  components: {
    hear,
    cioand,
    binad,
    RegionSelects
  },
  data() {
    return {
      tabPosition: "left",
      tab: "first",
      // second
      // 快递参数
      kuaidi_params: {
        limit: 10,
        offset: 0
      },
      kuai_parms: {
        page_limit: "",
        page: "",
        kws: "",
        status: -1
      },
      formAdress: {
        province: "",
        city: "",
        area: "",
        address: "",
        status: "",
        province_code: "",
        city_code: "",
        area_code: "",
        name: "",
        mobile: ""
      },
      // 快递总条数
      kuaidi_total: 0,
      baohan_total: 0,
      // 快递列表
      kuaidilist: [],
      jigouName: "",
      jigouNames: "",
      // 个人资料
      ziliaolist: {},
      labelPosition: "left",
      // 保函列表
      Bh_list: [],
      dizhilist: [],
      // 保函详情参数
      Bh_details: {
        offset: 0,
        limit: 10,
        user_id: sessionStorage.getItem("user_id")
      },
      username: sessionStorage.getItem("username"),
      cardname: sessionStorage.getItem("cardname"),
      dizhi_params: {
        limit: 10,
        offset: 0
      },
      // 保函详情内容
      Bh_content: {},
      // 保函总条数
      Bh_total: 0,
      // 发票参数
      fapiao_params: {
        offset: 0,
        limit: 10,
        keywords: ""
        // user_id: sessionStorage.getItem("user_id"),
      },
      baohan_params: {
        offset: 0,
        limit: 10,
        keywords: ""
        // user_id: sessionStorage.getItem("user_id"),
      },
      weidaili_search: "",
      // 发票总条数
      fapiao_total: 0,
      // 发票列表容器
      fapiaolist: [],
      // 修改密码参数
      form: {
        password: "",
        old_password: "",
        id: sessionStorage.getItem("user_id"),
        user_id: sessionStorage.getItem("user_id")
      },
      password_again: "",
      open6: false,
      formInfo: {
        cardname: "",
        mobile: "",
        cardback: "",
        cardfront: "",
        cardcode: ""
      },
      open10: false,
      title: "",
      dizhi_total: 0,
      addressDemo: {
        province: "",
        city: "",
        area: ""
      },
      loading:true,
    };
  },
  created() {
    //   this.get_weidaili();
    //   this.get_daili();
    this.getKuaidi();
    this.getZiliao();
    this.getBhlist();
    this.getBhdetail();
    this.getFapiao();
    this.addresslis();
    console.log("接受", this.$route.query.second);
    if (this.$route.query.second != undefined) {
      this.tab = this.$route.query.second;
    } else {
      this.tab = "first";
    }
    // this.tab=
  },
  methods: {
    kuaidishuaxin() {
      this.getKuaidi();
    },
    handleSizeChange_dizhi(val) {
      this.dizhi_parms.limit = val;
      this.addresslis();
    },
    handleCurrentChange_dizhi(val) {
      this.dizhi_parms.offset = parseInt(val - 1) * this.dizhi_parms.limit;
      this.addresslis();
    },
    shuxindizhi() {
      this.addresslis();
    },
    editAddress(item) {
      this.addressId = item.id;
      this.stateAddress = 2;
      this.open10 = true;
      this.title = "编辑地址";
      this.formAdress.province = item.province;
      this.formAdress.city = item.city;
      this.formAdress.area = item.area;
      this.formAdress.address = item.address;
      this.formAdress.status = item.status;
      this.formAdress.name = item.name;
      this.formAdress.mobile = item.mobile;
      this.formAdress.province_code = item.province_code;
      this.formAdress.city_code = item.city_code;
      this.formAdress.area_code = item.area_code;
      this.addressDemo = {
        province: item.province_code,
        city: item.city_code,
        area: item.area_code
      };
    },
    // 删除地址
    delAddress(id) {
      this.$confirm("是否要删除该地址?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deladdress({ id: id }).then(res => {
            console.log(res);
            if (res.data.code == 1) {
              this.getAddresslist();
              this.$message({
                type: "success",
                message: res.data.msg
              });
            } else {
              this.$message({
                message: res.data.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    addresslis() {
      addresslist(this.dizhi_parms).then(response => {
        if (response.data.code == 1) {
          this.dizhilist = response.data.data.rows;
          this.dizhi_total = response.data.data.total;
          // console.log("网络异常", response.data);
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    saveAddress() {
      if (this.stateAddress == 1) {
        addaddress({ ...this.formAdress }).then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.open10 = false;
            this.addresslis();
            this.$message({
              type: "success",
              message: res.data.msg
            });
          } else {
            this.$message({
              message: res.data.msg
            });
          }
        });
      } else {
        saveaddress({ ...this.formAdress, id: this.addressId }).then(res => {
          console.log(res);
          if (res.data.code == 1) {
            this.open10 = false;
            this.addresslis();
            this.$message({
              type: "success",
              message: res.data.msg
            });
          } else {
            this.$message({
              message: res.data.msg
            });
          }
        });
      }
    },
    // 选择地址
    regionChange(val) {
      console.log(this.addressDemo);
      console.log(val);
      // province_code:'',city_code:'',area_code:'',
      if (val.province) {
        this.formAdress.province_code = val.province.key;
        this.formAdress.province = val.province.value;
      }
      if (val.city) {
        this.formAdress.city_code = val.city.key;
        this.formAdress.city = val.city.value;
      }
      if (val.area) {
        this.formAdress.area_code = val.area.key;
        this.formAdress.area = val.area.value;
      }

      // this.formAdress.city_code = val.city.key
      // this.formAdress.area_code = val.area.key

      // this.formAdress.city = val.city.value
      // this.formAdress.area = val.area.value
    },
    shuxindizhi() {
      this.addresslis();
    },
    addAddress() {
      this.open10 = true;
      this.title = "新增地址";
      this.stateAddress = 1;
    },
    shiming() {
      this.open6 = true;
    },
    chakan(e) {
      console.log("跳转快递详情", e);
      this.$router.push({ name: "Exxpress", query: { order_no: e.order_no } });
    },
    bhchakan(e) {
      this.$router.push({
        name: "bhxq",
        query: { company_id: e.apply_number }
      });
    },
    // 实名认证
    save() {
      renzheng_geren({ ...this.formInfo }).then(res => {
        if (res.data.code == 1) {
          this.open6 = false;
          this.$message({
            message: res.data.msg,
            type: "success"
          });
        } else {
          this.$message({
            message: res.data.msg
          });
        }
      });
    },
    // 新增弹窗上传图片 正面
    handleAvatarSuccess1(file) {
      // console.log("图片11111111111", res, file);
      this.formInfo.cardfront = file.data.url;
    },
    // 新增弹窗上传图片 反面
    handleAvatarSuccess2(file) {
      // console.log("图片11111111111", res, file);
      this.formInfo.cardback = file.data.url;
    },
    // 删除正面照片
    handleRemove1() {
      this.$confirm("此操作将删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.formInfo.cardfront = "";
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 删除反面照片
    handleRemove1() {
      this.$confirm("此操作将删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.formInfo.cardback = "";
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 获取快递列表
    getKuaidi() {
 //快递报错
      (this.kuai_parms.page_limit = this.kuaidi_params.limit),
        (this.kuai_parms.page = this.kuaidi_params.offset),
        kuaidi(this.kuai_parms).then(res => {
          console.log("获取快递列表",res);
          if (res.data.code == 1) {
            this.loading = false;
            this.kuaidilist = res.data.data.data.list;
            this.kuaidi_total = res.data.data.data.total;
            console.log("快递列表", res.data, res.data.data.data.total);
          } else {
            this.$message.error("网络异常");
          }
        });
    },
    handleSizeChange_kuaidi(val) {
      console.log("handleSizeChange_kuaidi");
      this.kuaidi_params.limit = val;
      this.getKuaidi();
    },
    handleSizeChange_baohan(val) {
      this.Bh_details.limit = val;
      this.getBhlist();
    },
    handleCurrentChange_kuaidi(val) {
      console.log("handleCurrentChange_kuaidi", val);
      this.kuaidi_params.offset = parseInt(val - 1);
      this.getKuaidi();
    },
    handleCurrentChange_baohan(val) {
      this.Bh_details.offset = parseInt(val - 1) * this.Bh_details.limit;
      this.getBhlist();
    },
    kdxiang() {
      this.$alert("当前快递暂无详细信息", "", {
        confirmButtonText: "确定",
        callback: action => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      });
    },
    handleAdd() {
      console.log(123);
    },
    // 获取个人资料
    getZiliao() {
      // let user_id = sessionStorage.getItem("user_id");
      // console.log(user_id, "id");
      ziliao().then(res => {
        if (res.data.code == 1) {
          this.ziliaolist = res.data.data.info;
          // console.log(res.data.data.info.avatar,'--------------------');
          console.log("我的资料", res);
        } else {
          this.$message.error("网络异常");
        }
      });
    },

    // 退出登陆
    outs() {
      logou().then(res => {
        if (res.data.code == 1) {
          sessionStorage.removeItem("token");
          this.$message.success("退出登陆成功");
          this.$router.push("/login");
        } else {
          this.$$message.error("网络异常");
        }
      });
    },
    // 获取保函列表
    getBhlist() {
      bhlist(this.Bh_details).then(res => {
        if (res.data.code == 1) {
          this.Bh_list = res.data.data.rows;
          this.Bh_total = res.data.data.total;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    // 获取保函详情 点击详情按钮
    getBhdetail() {
      let bh_id = 1;
      bh_detail({ bh_id }).then(res => {
        if (res.data.code == 1) {
          this.Bh_content = res.data.data.jiben;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    handleSizeChange_bh(val) {
      this.Bh_details.limit = val;
      this.getBhlist();
    },
    handleCurrentChange_bh(val) {
      this.Bh_details.offset = parseInt(val - 1) * 10;
      this.getBhlist();
    },
    // 获取发票列表
    getFapiao() {
      fapiao(this.fapiao_params).then(res => {
        if (res.data.code == 1) {
          this.fapiaolist = res.data.data.rows;
          console.log("发票列表", this.fapiaolist);

          this.fapiao_total = res.data.data.total;
        } else {
          this.$message.error("网络异常");
        }
      });
    },
    // 申请发票
    handleshenqing(id) {
      shenqingkaipiao({ user_id: sessionStorage.getItem("user_id"), id }).then(
        res => {
          if (res.data.code == 1) {
            this.$message.success("申请成功");
            this.getFapiao();
          } else {
            this.$message.error(res.data.msg);
          }
        }
      );
    },
    handleSizeChange(val) {
      this.fapiao_params.limit = val;
      this.getFapiao();
    },
    handleCurrentChange(val) {
      this.fapiao_params.offset = parseInt(val - 1) * 10;
      this.getFapiao();
    },
    handkuaidi() {
      this.$router.push("/kuaidi");
    },
    handleSearch() {
      this.fapiao_params.keywords = this.weidaili_search;
      this.getFapiao();
    },
    // 修改密码
    updatepassword() {
      password(this.form).then(res => {
        if (res.data.code == 1) {
          this.$message.success("修改成功");
          this.form = {
            password: "",
            old_password: "",
            id: sessionStorage.getItem("user_id"),
            user_id: sessionStorage.getItem("user_id")
          };
          this.password_again = "";
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }
  }
  // mounted() {

  // },
};
</script>
<style>
.kiai .el-table__body-wrapper {
  height: 59vh;
  overflow: auto;
  /* overflow: hidden;
  position: relative; */
}

/* .el-form-item__content{
margin-left: 0px !important;
} */
</style>
<style scoped lang="scss">
.caakuia {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.update_password {
  margin-top: 100px;
  width: 100%;
  display: flex;
  justify-content: center;

  .update {
    width: 30%;
  }
}

::v-deep.el-form--inline .el-form-item {
  width: 100%;
}

::v-deep.el-form--inline .el-form-item__content {
  width: 100%;
}

.search {
  float: right;
  width: 20%;
  margin: 10px 0 10px 0;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;

  ::v-deep.el-input__inner {
    border: none !important;
  }

  .el-button {
    border: none;
  }
}

::v-deep.el-input__inner {
  border: none !important;
}

.block {
  float: right;
  padding-right: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  display: flex;
  justify-content: flex-end;
}

::v-deep.el-tabs--left {
  // min-height: calc(100vh - 72px);
  height: 100%;

  .el-tabs__item.is-left {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-family: MicrosoftYaHei-, MicrosoftYaHei;
    font-weight: normal;
    color: #000000;
  }

  .el-tabs__item.is-active {
    background: #1795ff;
    color: #fff;
  }
}

.cinoasd {
  display: flex;
  flex-direction: column;
}

.content_box {
  height: 100%;
  display: flex;
  flex-direction: column;

  .content {
    // margin: 0 auto;
    width: 100%;
    flex: 1;
    // padding: 0 2%;
    margin-top: 3px;
    background-color: #fff;
    // min-height: calc(100vh - 72px);

    .card_father {
      flex: 1;
      margin-top: 10px;
      overflow: auto;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      /* justify-content: space-between; */
      /* margin-left: 20px; */
      -ms-flex-line-pack: justify;
      align-content: space-between;
    }

    .card_fathers {
      // height: 76vh;
      /* padding-top: 10px; */
      margin-top: 10px;
      overflow: auto;
    }

    .card {
      width: 44%;
      height: 200px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
      border-radius: 8px 8px 8px 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      opacity: 1;
      margin: 20px;

      .card_bh {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .card_content_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 10px;

          .card_left {
            display: flex;
          }

          .card_right {
            display: flex;

            div {
              width: 145px;
              height: 47px;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 2px solid #1890ff;
              line-height: 47px;
              text-align: center;
              font-size: 18px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #1890ff;
              margin-right: 10px;
              cursor: pointer;
            }
          }

          .top_title {
            font-size: 24px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }

          .top_right {
            margin-left: -30px;
            width: 113px;
            height: 33px;
            background: #1795ff;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            font-size: 18px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 33px;
          }
        }

        .card_details {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 40px 0 10px;
          font-size: 18px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;

          .every {
            display: flex;
            align-items: center;

            i {
              color: #1890ff;
            }
          }
        }
      }

      .card_content {
        margin-left: 10px;
        height: 180px;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        span {
          // color: #ccc;
          color: #8c7878;
        }
      }

      .card_content_center {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin-right: 30px;
      }
    }

    .cards {
      width: 83%;
      height: 105px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
      border-radius: 8px 8px 8px 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      opacity: 1;
      margin: 20px auto;

      .card_bh {
        width: 100%;
        height: 100%;
        padding: 0 15px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .card_content_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-left: 10px;

          .card_left {
            display: flex;
          }

          .card_right {
            display: flex;

            div {
              width: 145px;
              height: 47px;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 2px solid #1890ff;
              line-height: 47px;
              text-align: center;
              font-size: 18px;
              font-family: Microsoft YaHei-Regular, Microsoft YaHei;
              font-weight: 400;
              color: #1890ff;
              margin-right: 10px;
              cursor: pointer;
            }
          }

          .top_title {
            font-size: 24px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }

          .top_right {
            margin-left: -30px;
            width: 113px;
            height: 33px;
            background: #1795ff;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            font-size: 18px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 33px;
          }
        }

        .card_details {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0 40px 0 10px;
          font-size: 18px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;

          .every {
            display: flex;
            align-items: center;

            i {
              color: #1890ff;
            }
          }
        }
      }

      .card_content {
        margin-left: 10px;
        height: 180px;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        span {
          color: #ccc;
        }
      }

      .card_content_center {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin-right: 30px;
      }
    }

    .card_content_bottom {
      display: flex;

      .right_content {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }

    .card_right {
      margin-right: 30px;
    }
  }
  .wuhuxin {
    // justify-content: center;
    height: calc(100vh - 152px);
    display: flex;
    flex-direction: column;
  }
  .personal_box {
    width: 100%;
    margin-top: 20px;
    display: flex;
    overflow: auto;
    justify-content: center;
    height: calc(100vh - 171px);
    .box_personal_content {
      width: 70%;
    }
  }

  .Personal {
    width: 40%;
  }

  // ::v-deep .Personal .el-input__inner {
  //   width: 100%;
  //   border: 0;
  //   border-bottom: #ccc 1px solid;
  //   border-radius: 0;
  //   padding: 0;
  // }
  // ::v-deep.el-input.is-disabled .el-input__inner {
  //   background-color: #fff;
  //   color: #000000;
  // }
}

.photo {
  border-radius: 50%;
  width: 100px;
}

.kuaidcaa {
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-content: center;
}

.el-form-item {
  margin-bottom: 10px !important;
  display: flex;
  align-items: center;
}

.el-form-item__label {
  line-height: 0 !important;
}

// ::v-deep .el-input__inner{
//   width: 100% !important;
// }
.imgBox {
  display: flex;
  flex-direction: column;
  width: 100%;
  // height: 120px;
  margin-bottom: 10px;
  align-items: flex-end;
}

.but {
  width: 100px;
  height: 40px;
  color: #1795ff;
  border: 1px solid #1795ff;
}

.but-con {
  margin-left: 25%;
  margin-top: 20px;
}

.renzhng {
  flex: 1;
  overflow-y: auto;
  padding: 0 10%;
}

.footer {
  display: flex;
  padding-left: 10px;
  box-sizing: border-box;
  height: 45px;
  // justify-content: center;
  align-items: center;
  background-color: #f4f4f5 !important;

  .btn {
    width: 80px;
    height: 35px;
    border: 1px solid #1795ff;
  }
}

// 上传图片

.avatar-uploader-icon {
  background: rgba(0, 0, 0, 0.02);
  border-radius: 4px 4px 4px 4px;
  border: 1px dashed rgba(0, 0, 0, 0.15);
  font-size: 14px;
  color: #8c939d;
  width: 100%;
  height: 138px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .el-icon-plus {
    font-size: 28px;
  }
}

.avatar {
  width: 50%;
  height: 138px;
  display: flex;
  align-items: center;
  font-size: 20px;

  // margin-bottom: 8px;
  img {
    width: 100%;
    height: 100%;
    margin-right: 8px;
  }
}

.rzBox {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%);

  .el-button {
    width: 110px !important;
  }
}
.box-card {
  width: 80%;
}

.box-card-top {
  display: flex;
  align-items: center;
  height: 40px;

  h1 {
    color: #333;
    font-size: 16px;
    font-weight: bold;
  }

  span {
    color: #999;
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/userCenter/index.vue